// extracted by mini-css-extract-plugin
module.exports =  {"imageDesc":"imageDesc__I6MZJ","highlight":"highlight__irA3T"};